import React from 'react';
import { GenericFormPage, GenericDetailPage } from '../../../components/generic';
import { useAccOperationalType, AccOperationalType } from './useData';
import {
  moduleConfig,
  getDetailSections,
  getInitialFormData,
  mapItemToFormData,
  getStatusBadges,
} from './config';

export { default as List } from './List';

export const Form: React.FC = () => (
  <GenericFormPage<AccOperationalType>
    useData={useAccOperationalType}
    config={{ ...moduleConfig, getInitialFormData, mapItemToFormData }}
  />
);

export const Detail: React.FC = () => (
  <GenericDetailPage<AccOperationalType>
    useData={useAccOperationalType}
    config={{ ...moduleConfig, getDetailSections, getStatusBadges }}
  />
);
